import { CREDIT_LIMITS } from './constants.js';



/**
 * Get chip color for semester credits based on optimal range
 * @param {number} credits - Current credits
 * @returns {string} - Material-UI chip color
 */
export const getSemesterChipColor = (credits) => {
  if (credits >= (CREDIT_LIMITS.SEMESTER_OPTIMAL - CREDIT_LIMITS.SEMESTER_OPTIMAL_RANGE) && 
      credits <= (CREDIT_LIMITS.SEMESTER_OPTIMAL + CREDIT_LIMITS.SEMESTER_OPTIMAL_RANGE)) {
    return 'success'; // Optimal range (25-35)
  }
  if (credits > 0) return 'error'; // Outside optimal range
  return 'default'; // No credits selected
};

/**
 * Get chip color for period credits based on optimal range
 * @param {number} credits - Current credits
 * @returns {string} - Material-UI chip color
 */
export const getPeriodChipColor = (credits) => {
  if (credits >= (CREDIT_LIMITS.PERIOD_OPTIMAL - CREDIT_LIMITS.PERIOD_OPTIMAL_RANGE) && 
      credits <= (CREDIT_LIMITS.PERIOD_OPTIMAL + CREDIT_LIMITS.PERIOD_OPTIMAL_RANGE)) {
    return 'success'; // Optimal range (12-18)
  }
  if (credits > 0) return 'error'; // Outside optimal range
  return 'default'; // No credits selected
};

/**
 * Get chip color for remaining credits
 * @param {number} remainingCredits - Credits remaining until limit
 * @returns {string} - Material-UI chip color
 */
export const getRemainingCreditsColor = (remainingCredits) => {
  if (remainingCredits <= 0) return 'error'; // At or over limit
  if (remainingCredits <= 5) return 'warning'; // Close to limit
  return 'info'; // Plenty of room
}; 